module.exports = __webpack_public_path__ + "img/sorry.ae52c046.jpg";